/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { qreq } from "../../shared/qrequest";
import BaseCom from "../BaseCom";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import L from "../Lang";
import Icon from "../Icon";

class InStock extends BaseCom {

    async componentDidMount() {
        super.componentDidMount();
        await this.load();
    }

    load = async () => {
        try {
            let j = await qreq.getAsync('/api/inventory/instock');
            if (j.list) {
                j.list.forEach(i => {
                    this.pullSizeFromName(i);
                });
                this.setState({ list: j.list });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    pullSizeFromName(item) {
        if (!item.productName) return;
        if (item.isPricePerUnit) return;
        const regex = /[0-9]+x[0-9]+/;
        const size = item.productName.match(regex);
        if (size) {
            item.productName = item.productName.replace(size, '').trim();
            item.productSize = size;
        }
        else
            item.productSize = 'Standard';
    }

    sort = (name) => {
        const desc = !this.state.desc;
        console.log('sort', name, desc);
        let list = [...this.state.list];
        list = list.sort((a, b) => {
            if (a[name] < b[name]) return -1;
            else if (a[name] < b[name]) return 1;
            else return 0;
        });
        if (desc) list.reverse();
        this.setState({ list: list, lastSort: name, desc: desc });
    }

    render() {
        return (
            <div className="container-fluid">
                <h1><L>In Stock</L></h1>
                <table className="table c-datatable table-striped">
                    <thead>
                        <tr>
                            <th class="sortable" role="button" onClick={() => this.sort('productName')}>
                                <L>Product</L> {this.state.lastSort === 'productName' && (this.state.desc ? <Icon icon="faCaretUp" /> : <Icon icon="faCaretDown" />)}
                            </th>
                            <th class="sortable" role="button" onClick={() => this.sort('catalogCode')}>
                                <L>Catalog Code</L> {this.state.lastSort === 'catalogCode' && (this.state.desc ? <Icon icon="faCaretUp" /> : <Icon icon="faCaretDown" />)}
                            </th>
                            <th class="sortable" role="button" onClick={() => this.sort('productSize')}>
                                <L>Size</L> {this.state.lastSort === 'productSize' && (this.state.desc ? <Icon icon="faCaretUp" /> : <Icon icon="faCaretDown" />)}
                            </th>
                            <th class="sortable" role="button" onClick={() => this.sort('counter')}>
                                <L>Quantity</L> {this.state.lastSort === 'counter' && (this.state.desc ? <Icon icon="faCaretUp" /> : <Icon icon="faCaretDown" />)}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.list?.map((i, idx) => <tr key={idx}>
                            <td>{i.productName}</td>
                            <td>{i.catalogCode}</td>
                            <td>{i.productSize}</td>
                            <td>{i.counter}</td>
                        </tr>)}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default withParamsAndNavigate(InStock);